import { useQuery, useMutation, QueryHookOptions } from '@apollo/client';

import {
  GET_CONFIGURATIONS,
  GET_CONFIGURATION,
  GET_CONFIGURATIONS_BY_CATEGORY,
  CREATE_CONFIGURATION,
  UPDATE_CONFIGURATION,
  DELETE_CONFIGURATION,
  CREATE_DEFAULT_CONFIGURATIONS,
} from '~/graphql/query-mutation/configuration';

// Types based on GraphQL schema
export interface Configuration {
  _id: string;
  key: string;
  value: any;
  description: string;
  category: string;
  dataType: 'NUMBER' | 'STRING' | 'BOOLEAN' | 'OBJECT';
  isActive: boolean;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface ConfigurationFilter {
  category?: string;
  isActive?: boolean;
  key?: string;
}

export interface ConfigurationInput {
  key: string;
  value: any;
  description: string;
  category: string;
  dataType: 'NUMBER' | 'STRING' | 'BOOLEAN' | 'OBJECT';
  isActive?: boolean;
}

export interface UpdateConfigurationInput {
  value?: any;
  description?: string;
  category?: string;
  dataType?: 'NUMBER' | 'STRING' | 'BOOLEAN' | 'OBJECT';
  isActive?: boolean;
}

// Query Hooks
export const useConfigurations = (
  filter?: ConfigurationFilter,
  page: number = 1,
  pageSize: number = 20,
  options?: QueryHookOptions
) => {
  return useQuery(GET_CONFIGURATIONS, {
    variables: { filter, page, pageSize },
    ...options,
  });
};

export const useConfiguration = (key: string, options?: QueryHookOptions) => {
  return useQuery(GET_CONFIGURATION, {
    variables: { key },
    skip: !key,
    ...options,
  });
};

export const useConfigurationsByCategory = (
  category: string,
  options?: QueryHookOptions
) => {
  return useQuery(GET_CONFIGURATIONS_BY_CATEGORY, {
    variables: { category },
    skip: !category,
    ...options,
  });
};

// Mutation Hooks
export const useCreateConfiguration = () => {
  return useMutation(CREATE_CONFIGURATION, {
    refetchQueries: [GET_CONFIGURATIONS],
  });
};

export const useUpdateConfiguration = () => {
  return useMutation(UPDATE_CONFIGURATION, {
    refetchQueries: [GET_CONFIGURATIONS],
  });
};

export const useDeleteConfiguration = () => {
  return useMutation(DELETE_CONFIGURATION, {
    refetchQueries: [GET_CONFIGURATIONS],
  });
};

export const useCreateDefaultConfigurations = () => {
  return useMutation(CREATE_DEFAULT_CONFIGURATIONS, {
    refetchQueries: [GET_CONFIGURATIONS],
  });
};
